import { useEffect, useRef, useState } from 'react';
import IMask from 'imask';

export const MaskedSinInput = ({
  value,
  onChange,
  onBlur,
  onKeyDown,
  placeholder = '___-___-___',
  id,
}) => {
  const inputRef = useRef(null);
  const maskRef = useRef(null);
  const [isMaskEmpty, setIsMaskEmpty] = useState(true);

useEffect(() => {
  if (inputRef.current) {
    maskRef.current = IMask(inputRef.current, {
      mask: '000-000-000',
      lazy: false,
      placeholderChar: '_',
    });

    if (value) {
      // Set unmasked value so IMask formats it properly
      maskRef.current.unmaskedValue = value.replace(/-/g, ''); // <- Remove any dashes first
      setIsMaskEmpty(maskRef.current.unmaskedValue.length === 0);
    }

    maskRef.current.on('accept', () => {
      const masked = maskRef.current.value;
      const unmasked = maskRef.current.unmaskedValue;

      setIsMaskEmpty(unmasked.length === 0);

      const event = {
        target: {
          value: unmasked.length === 0 ? "" : unmasked,
          masked,
          name: id,
        },
      };

      onChange?.(event);
    });
  }

  return () => {
    if (maskRef.current) {
      maskRef.current.destroy();
      maskRef.current = null;
    }
  };
}, [onChange, id, value]);
  return (
    <input
      ref={inputRef}
      id={id}
      className={`form-control ${isMaskEmpty ? 'mask-empty' : ''}`}
      type="text"
      placeholder={placeholder}
      onBlur={onBlur}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          event.target.blur();
        }
        if (onKeyDown) onKeyDown(event);
      }}
    />
  );
};
